import * as Api from '@ViewModels';
import { inject } from 'mobx-react';
import Waypoint from 'react-waypoint';
import { ImpersonationContextKey } from '../../../../models';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { filterCancelledSocialPosts } from '../../../../utils/socialMediaFiltering';
import { Portal } from '../../Portal';
import { SocialMediaReportingTable } from './SocialMediaReportingTable';
import { useSocialReporting } from './hooks/useSocialReporting';
import { SocialMediaReportingTableRow } from './presentation';

interface IProps {
	impersonationContext: Api.IImpersonationContext;
	scrollToBottomPortalId: string;
}

const _AdminSocialMediaReportingTable = ({ impersonationContext, scrollToBottomPortalId }: IProps) => {
	const data = useSocialReporting({ impersonationContext });
	const userSession = useUserSession();
	const renderWaypoint = () => {
		if (!data.socialMediaPostsQuery.hasNextPage || data.socialMediaPostsQuery.isFetchingNextPage) {
			return null;
		}
		return (
			<Portal destination={scrollToBottomPortalId}>
				<Waypoint
					bottomOffset='-200px'
					onEnter={() => {
						data.socialMediaPostsQuery.fetchNextPage();
					}}
				/>
			</Portal>
		);
	};

	return (
		<div>
			<SocialMediaReportingTable {...data}>
				{data.socialMediaPostsQuery.status === 'success'
					? data.socialMediaPostsQuery.data.pages.map(group => {
							const isExplicitlyCancelledFilter = data.selectedPostStatus?.includes(Api.PostStatus.Cancelled);
							const filteredPosts = filterCancelledSocialPosts(group.values, isExplicitlyCancelledFilter);
							return filteredPosts.map(item => {
								const itemVm = new Api.SocialMediaPostReportViewModel(userSession, item).impersonate(
									impersonationContext
								);
								return (
									<SocialMediaReportingTableRow
										key={itemVm.id}
										report={itemVm}
										impersonationContext={impersonationContext}
									/>
								);
							});
						})
					: null}
			</SocialMediaReportingTable>
			{renderWaypoint()}
		</div>
	);
};

export const AdminSocialMediaReportingTable = inject(ImpersonationContextKey)(_AdminSocialMediaReportingTable);
